import 'regenerator-runtime/runtime'
import SearchIcon from '@mui/icons-material/Search'
import React, { useRef } from 'react'
import PropTypes from 'prop-types'

export const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  const inputRef = useRef(null)

  return (
    <div className="tableSearch">
      <input
        ref={inputRef}
        type="search"
        placeholder="Search Table"
        value={globalFilter ?? ''}
        onChange={(e) => {
          setGlobalFilter(e.target.value ?? undefined)
        }}
      />
      <SearchIcon className="material-icons-two-tone" />
    </div>
  )
}

GlobalFilter.propTypes = {
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
}
